/* eslint-disable @next/next/no-img-element */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';

const Logo = ({ url }) => (
  <div className={styles.logo}>
    <img src={url} alt="logo" />
  </div>
);

Logo.propTypes = {
  url: PropTypes.string
};

export default Logo;
